import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { confirmPasswordReset } from 'firebase/auth';
import { auth } from './../firebase/firebaseConfig';
import './css/Login.css';
import PageTitle from './includes/PageTitle';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const origin = searchParams.get('origin');
    if (origin !== 'forgot-password') {
      navigate('/forgot-password');
    }
  }, [searchParams, navigate]);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }
    if (password.length < 8 || password.length > 12) {
      setErrorMessage("Password must be between 8 to 12 characters.");
      return;
    }
    setLoading(true);
    const oobCode = searchParams.get('oobCode');
    try {
      await confirmPasswordReset(auth, oobCode, password);
      setSuccessMessage('Password reset successful. Redirecting to sign-in page...');
      setTimeout(() => {
        navigate('/sign-in');
      }, 3000);
    } catch (error) {
      setErrorMessage("An error occurred while resetting your password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle title="Reset Password - ALMOSTINVISIBLE" />
      <div style={{ marginTop: "22vh", display: "flex", justifyContent: "center" }}>
        <form className="form" onSubmit={handlePasswordReset}>
          <h1 className="unbounded black-bordered-bottom">RESET PASSWORD</h1>
          {successMessage && (
            <div className="alert alert-success alert-dismissible fade show mt-3" role="alert">
              {successMessage}
              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          )}
          {errorMessage && (
            <div className="alert alert-danger alert-dismissible fade show mt-3" role="alert">
              {errorMessage}
              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          )}

          <div>
            <div className="flex-column">
              <label className='nunito-2'>New Password*</label>
            </div>
            <div className="inputForm">
              <input
                type="password"
                className="input"
                placeholder="Enter your new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <div>
            <div className="flex-column">
              <label className='nunito-2'>Confirm Password*</label>
            </div>
            <div className="inputForm">
              <input
                type="password"
                className="input"
                placeholder="Confirm your new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="d-flex justify-content-center mt-3">
            <button className="black-button" type="submit" disabled={loading}>
              {loading ? <div className="spinner-border spinner-border-sm" role="status"></div> : 'Save'}
            </button>
          </div>
        </form>
      </div>    </>
  );
}
